module.exports = __webpack_public_path__ + "img/deliver.39b41b4a.svg";